export default __webpack_public_path__ + "static/media/B_wdt_c_cap_1.758e8d48.mp3";